import { useQuery } from "@tanstack/react-query";
import { ApiError, get } from "./client";
import type { SiteRef } from "./quotations";

/** `/api/v1/invoices`, read-only: an invoice keeps saying what was invoiced. */

export interface InvoiceRow {
  id: number;
  number: string;
  invoice_date: string | null;
  issued_at: string | null;
  issued_by: string | null;
  /** The bill invoiced, and the job it was raised from. */
  boq: { id: number; name: string; status: string; quotation_id: number | null } | null;
  site: SiteRef | null;
  gross_excl_vat: string;
  penalty_rate: string;
  penalty: string;
  excl_vat: string;
  vat_rate: string;
  vat: string;
  total_incl_vat: string;
  boq_now_excl_vat: string | null;
  boq_differs: boolean;
  pdf_url: string;
}

export const INVOICES_KEY = ["invoices"] as const;

export function useInvoices() {
  return useQuery<{ rows: InvoiceRow[] }, ApiError>({
    queryKey: INVOICES_KEY,
    queryFn: () => get<{ rows: InvoiceRow[] }>("/api/v1/invoices"),
  });
}

export function useInvoice(id: number | null) {
  return useQuery<InvoiceRow, ApiError>({
    queryKey: ["invoices", id],
    queryFn: () => get<InvoiceRow>(`/api/v1/invoices/${id}`),
    enabled: id !== null,
  });
}
